import React from 'react';
import { useMoneyFormat } from '../../context/LocaleContext';
import { figureOrDash } from '../../domain/reading';
import s from './StatTiles.module.css';

// The stat row across the top of Home.
//
// MMS shows five tiles: Events left this week, Payments received this month,
// Projected revenue this month, Active Students, Reviews Pending. Ours are the
// core's four `homeTiles` (src/domain/home.js): Lessons today, Active Students,
// You're owed, Payments received this month.
//
// A tile whose `known` is false has reads that have not answered, and shows
// the dash in place of its figure (#629): a zero there is an answer.
export default function StatTiles({ tiles }) {
  const format = useMoneyFormat();
  return (
    <div className={s.tiles}>
      {tiles.map((t) => (
        <div className={s.tile} key={t.label}>
          <div className={s.value}>{figureOrDash(t.known !== false, t.money ? format(t.value) : t.value)}</div>
          <div className={s.label}>{t.label}</div>
        </div>
      ))}
    </div>
  );
}
